import { InsuredElementState, InsuredGoodState } from './insuredElement.state';

export const ACTION_TYPES = {
  GET_SELLING_POINTS: 'transverse/GET_SELLING_POINTS',
  GET_INSURED_GOOD_TYPES: 'transverse/GET_INSURED_GOOD_TYPES',
  UPDATE_INSURED_GOOD: 'insuredElement/UPDATE_INSURED_GOOD'
};

export type GetSellingPointAction = {
  type: typeof ACTION_TYPES.GET_SELLING_POINTS;
  payload: InsuredElementState;
};
export type GetInsuredGoodTypeAction = {
  type: typeof ACTION_TYPES.GET_INSURED_GOOD_TYPES;
  payload: InsuredElementState;
};

export type updateInsuredGood = {
  type: typeof ACTION_TYPES.UPDATE_INSURED_GOOD;
  payload: InsuredGoodState;
};
